import { useState } from "react";
import { useOnboarding } from "../../contexts/OnboardingContext";
import { LanguageChoice } from "../../types/onboarding";
import LanguagesSelector, { LanguageWithProficiency } from "../shared/LanguagesSelector";
import OnboardingLayout from "./OnboardingLayout";

interface LanguagesToLearnStepProps {
  onContinue: (languages: LanguageChoice[]) => void;
  initialValue: LanguageChoice[];
}

export default function LanguagesToLearnStep({ onContinue, initialValue }: LanguagesToLearnStepProps) {
  const { data, setData } = useOnboarding();
  const [languages, setLanguages] = useState<LanguageWithProficiency[]>(
    // Map initial values to the format expected by the LanguagesSelector
    data.languagesToLearn.map((lang) => ({
      languageCode: lang.languageCode,
      proficiency: lang.proficiency,
    }))
  );

  const handleLanguagesChange = (updatedLanguages: LanguageWithProficiency[]) => {
    setLanguages(updatedLanguages);

    // Update context data
    const apiFormat: LanguageChoice[] = updatedLanguages.map((lang) => ({
      languageCode: lang.languageCode,
      proficiency: lang.proficiency,
    }));

    setData((prev) => ({ ...prev, languagesToLearn: apiFormat }));
  };

  const handleSubmit = () => {
    if (languages.length <= 0) return;

    // Convert to the format expected by the API
    const apiFormat: LanguageChoice[] = languages.map((lang) => ({
      languageCode: lang.languageCode,
      proficiency: lang.proficiency,
    }));

    onContinue(apiFormat);
  };

  return (
    <OnboardingLayout
      title="Ok. What languages do you want to learn?"
      onContinue={handleSubmit}
      canContinue={languages.length > 0}
      step={1}
      totalSteps={5}
    >
      <div className="space-y-5">
        <LanguagesSelector languages={languages} onChange={handleLanguagesChange} withProficiency={true} />
      </div>
    </OnboardingLayout>
  );
}
